import { render, staticRenderFns } from "./WhatsappImportStatusViewer.vue?vue&type=template&id=5a2a790b&scoped=true"
import script from "./WhatsappImportStatusViewer.vue?vue&type=script&lang=js"
export * from "./WhatsappImportStatusViewer.vue?vue&type=script&lang=js"
import style0 from "./WhatsappImportStatusViewer.vue?vue&type=style&index=0&id=5a2a790b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a790b",
  null
  
)

export default component.exports